export const amountString = (num?: string, notComma?: boolean, digit?: number): string => {
  const replaceForm = /\B(?=(\d{3})+(?!\d))/g
  let top: string
  const digits = digit ? digit + 1 : 4

  if (num == null || !/^[-]?[0-9]+(\.[0-9]+)?$/g.test(num)) {
    return '0'
  }
  if (num.indexOf('.') !== -1) {
    if (notComma) {
      top = num.substring(0, num.indexOf('.'))
    } else {
      top = num.substring(0, num.indexOf('.')).replace(replaceForm, ',')
    }
    const bottom = Number(num.substring(num.indexOf('.'), num.indexOf('.') + digits))
      .toString()
      .slice(1)

    if (bottom.indexOf('e') > -1 || bottom.indexOf('E') > -1) {
      return top + num.substring(num.indexOf('.'), num.indexOf('.') + digits)
    } else {
      return `${top}${bottom}`
    }
  }
  if (notComma) {
    return num
  } else {
    return num.replace(replaceForm, ',')
  }
}

export const maskingPhoneNumber = (num: string | null | undefined) => {
  if (!num) return num
  try {
    const platNum = num.split('-').join('')
    return `${platNum.substring(0, 3)}-****-${platNum.substring(7, 12)}`
  } catch {
    return num
  }
}

export const maskingAccount = (account: string | number | null | undefined) => {
  if (!account) return account
  try {
    const platAccount = String(account).split('-').join('')
    return `${platAccount.substring(0, platAccount.length - 5)}*****`
  } catch {
    return account
  }
}

export const maskingName = (name: string | null | undefined) => {
  if (!name) return name
  try {
    const nameLength = name.length
    const firstName = name.substring(0, 1)

    if (nameLength === 2) return `${firstName}*`

    const masking = name
      .split('')
      .filter((_, i) => i !== 0 && i === nameLength - 1)
      .map(() => '*')
      .join('')

    return `${firstName}${masking}${name.split('').pop()}`
  } catch {
    return name
  }
}

export const maskingEmail = (email: string) => {
  if (!email) return email
  try {
    const splitEmail = email.split('@')
    const mailName = splitEmail[0]
    const domain = splitEmail[1]
    if (mailName.length === 2) return `${mailName.substring(0, 1)}*@${domain}`

    const masking = () => {
      let str = ''
      for (let i = 0; i < mailName.length - 2; i++) {
        str += '*'
      }
      return str
    }

    return `${mailName.split('')[0]}${masking()}${mailName.split('').pop()}@${domain}`
  } catch {
    return email
  }
}
